<script>
  import { link } from "svelte-spa-router";
  import { createEventDispatcher, onMount } from "svelte";
  import axios from "axios";
  import config from "../../stores/config";
  import * as ls from "local-storage";
  import CutSheetPrint from "../FStyles/Utils/CutSheetPrint.svelte";

  export let orderID = "";
  export let _id = "";
  export let completed;
  export let dateOrdered;
  export let completedOn;
  export let ref;
  export let earliestDelivery;
  export let items;
  export let customerID;
  export let addInfo;

  const dispatch = createEventDispatcher();

  const handleDelete = () => {
    let confirmDelete = confirm(`Do you wish to delete this Order?`);

    if (confirmDelete) {
      axios
        .delete(`${$config.backendURL}/orders/${_id}`, {
          headers: { authorization: ls.get("jwt") },
        })
        .then((res) => {
          dispatch("delete");
        })
        .catch((err) => {
          console.log(err);
          alert(err);
        });
    }
  };

  let dateDiffEarly;

  onMount(() => {
    function getDays(start, last) {
      //initialize dates with Date object
      const date1 = new Date(start);
      const date2 = new Date(last);

      // calculation for converting a day into milliseconds
      const oneDay = 1000 * 60 * 60 * 24;

      // calculation for the time difference between start and last
      const diffTime = date2.getTime() - date1.getTime();

      // calculation for the days between start and last
      const diffDays = Math.round(diffTime / oneDay);
      // return number of days
      return diffDays;
    }

    let today = new Date().toISOString().slice(0, 10);

    dateDiffEarly = getDays(today, earliestDelivery);
  });

  let showPrint = false;
</script>

<div class="hidden bg-red-50" />
<div class="hidden bg-red-100" />

<div class="tr tracking-wider border-b border-gray-100">
  <div style="min-width: 11rem; max-width: 11rem;" class="flex items-center">
    <button class="text-base btn btn-red-outline mr-2" on:click={handleDelete}>
      <i class="fas fa-trash" />
    </button>
    <a href={`/orders/${_id}`} use:link class="text-base btn btn-gray-outline">
      <i class="fas fa-eye" />
    </a>
    <button
      class="text-base btn btn-red ml-2"
      on:click={() => (showPrint = true)}
    >
      <i class="fas fa-print" />
    </button>
  </div>
  <div style="min-width: 7rem; max-width: 7rem;">
    ORDER #{orderID}
  </div>
  <div style="min-width: 10rem; max-width: 10rem;">
    {new Date(dateOrdered).toDateString() || "N/A"}
  </div>

  {#if completed}
    <div style="min-width: 15rem; max-width: 15rem;" class="flex items-center">
      <div class="o-pill px-3 py-1 bg-green-200 text-green-700 mr-2">✔</div>
      N/A - Order Closed
    </div>
  {:else}
    <div style="min-width: 15rem; max-width: 15rem;" class="flex items-center">
      {#if earliestDelivery != "N/A"}
        {#if dateDiffEarly < 0}
          <div class="o-pill px-2 py-1 bg-red-200 text-red-700 mr-2">
            Overdue
          </div>
          {new Date(earliestDelivery).toDateString() || "N/A"}
        {:else if dateDiffEarly == 0}
          <div class="o-pill px-2 py-1 bg-gray-700 text-gray-200 mr-2">
            Today
          </div>
          {new Date(earliestDelivery).toDateString() || "N/A"}
        {:else if dateDiffEarly < 8}
          <div class="o-pill px-2 py-1 bg-yellow-200 text-yellow-700 mr-2">
            In 1 week
          </div>
          {new Date(earliestDelivery).toDateString() || "N/A"}
        {:else if dateDiffEarly < 15}
          <div class="o-pill px-2 py-1 bg-blue-200 text-blue-700 mr-2">
            In 2 week
          </div>
          {new Date(earliestDelivery).toDateString() || "N/A"}
        {:else}
          <div class="o-pill px-2 py-1 bg-green-200 text-green-700 mr-2">
            {dateDiffEarly} days left
          </div>
          {new Date(earliestDelivery).toDateString() || "N/A"}
        {/if}
      {:else}
        <div class="o-pill px-3 py-1 bg-yellow-200 text-yellow-700 mr-2">!</div>
        This order is empty
      {/if}
    </div>
  {/if}

  <div style="min-width: 7rem; max-width: 7rem;">
    {#if completed}
      <div class="o-pill px-2 py-1 bg-blue-200 text-blue-700">CLOSED</div>
    {:else}
      <div class="o-pill px-2 py-1 bg-red-200 text-red-700">OPEN</div>
    {/if}
  </div>
  <div style="min-width: 8.5rem; max-width: 8.5rem;">
    {completedOn ? new Date(completedOn).toDateString() : "N/A"}
  </div>
  <div style="min-width: 27.5rem; max-width: 27.5rem;">
    {ref}
  </div>
</div>

<CutSheetPrint
  {orderID}
  {items}
  {customerID}
  {earliestDelivery}
  {addInfo}
  orderMongoID={_id}
  show={showPrint}
  on:close={() => (showPrint = false)}
/>

<style>
  .tr {
    display: flex;
    align-items: center;
    width: max-content;
    padding: 10px 20px;
  }

  .o-pill {
    display: inline-block;
    border-radius: 9999px;
    font-size: 0.75rem;
    line-height: 1rem;
  }
</style>
